export default __webpack_public_path__ + "static/media/invalid.425cd560.svg";